import { useEffect } from 'react';
import './FireflyEffect.css';

const FireflyEffect = ({ count = 150 }) => {
  useEffect(() => {
    let container = document.getElementById('firefly-container');

    if (!container) {
      container = document.createElement('div');
      container.id = 'firefly-container';
      document.body.appendChild(container);
    } else {
      container.innerHTML = ''; // clear if it already exists
    }

    for (let i = 0; i < count; i++) {
      const firefly = document.createElement('div');
      firefly.classList.add('firefly');
      firefly.style.left = `${Math.random() * 100}vw`;
      firefly.style.top = `${Math.random() * 100}vh`;
      firefly.style.animationDuration = `${Math.random() * 5 + 3}s`;
      firefly.style.setProperty('--x', `${Math.random() * 20 - 10}vw`);
      firefly.style.setProperty('--y', `${Math.random() * 20 - 10}vh`);
      container.appendChild(firefly);
    }

    // Optional: Cleanup on unmount
    return () => {
      if (container) container.innerHTML = '';
    };
  }, [count]);

  return null; // no visible JSX needed
};

export default FireflyEffect;
